<template>
    <div id="core_waybills_label_svg">
        <div class="ui form">
            <div class="field" v-if="is_show_input">
                <label>
                    <!-- 號碼 範例:123,456,789 -->
                    {{ $t('ui.toolbox.core_waybills_label_svg.helps.numbers_input') }}
                </label>
                <input type="text" v-model="current_numbers">
            </div>
            <Label v-if="!is_new_label"
                :numbers="numbers"
                :label_type="printing_type"
                :authentication_token="authentication_token"
                :staff_identity="staff_identity"
                :is_show_input="is_show_input"
                :scope="scope"
                :node_carrier_name="node_carrier_name"
                :is_post_method="is_post_method"
                :channel="channel">
                <div class="field" slot="button">
                    <label>&emsp;</label>
                    <div class="ui basic black button"
                        @click.prevent="is_new_label = true">
                        {{ $t('ui.toolbox.core_waybills_label_svg.btns.new_print') }}
                    </div>
                </div>
            </Label>
            <NewLabel v-else
                :numbers="numbers"
                :printing_type="printing_type"
                :paper_size="paper_size"
                :template="template"
                :authentication_token="authentication_token"
                :staff_identity="staff_identity"
                :is_show_input="is_show_input"
                :scope="scope"
                :node_carrier_name="node_carrier_name"
                :is_post_method="is_post_method"
                :channel="channel">
                <div class="field" slot="button">
                    <label>&emsp;</label>
                    <div class="ui basic black button"
                        @click.prevent="is_new_label = false">
                        {{ $t('ui.toolbox.core_waybills_label_svg.btns.old_print') }}
                    </div>
                </div>
            </NewLabel>
            <!-- new_label -->
            <!-- <div v-if="!errors" class="field">
                <label>&emsp;</label>
                <div class="ui button"
                    @click.prevent="is_new_label = false">
                    {{ '舊版列印' }}
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
import Label from './label.vue'
import NewLabel from './new_label.vue'

export default {
    name: "ToolCoreWaybillsLabelSvgMain",
    components: {
        Label,
        NewLabel,
    },
    props: {
        numbers: {
            type: Array,
            default: []
        },
        authentication_token: {
            type: String,
            default: ""
        },
        staff_identity: {
            type: String,
            default: ""
        },
        printing_type: {
            type: String,
            default: ""
        },
        paper_size: {
            type: String,
            default: "A4"
        },
        template: {
            type: String,
            default: "1x1"
        },
        is_show_input: {
            type: Boolean,
            default: true,
        },
        scope: {
            type: String,
            default: "provider"
        },
        node_carrier_name: {
            type: String,
            default: ""
        },
        is_post_method: {
            type: Boolean,
            default: false
        },
        channel: String,
    },
    data() {
        return {
            is_initialized: false,
            is_processing: false,
            is_new_label: true,
            errors: "",
        }
    },
    computed: {
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
    },
}
</script>

<style scoped lang="scss">
    .ui.form .fields {
        margin: 0 ;
    }
</style>
